"use client";

import Image from "next/image";
import { useState } from "react";
const styles = new Proxy({"Wrapper":"Wrapper-33e95","Inner":"Inner-33e95","Card":"Card-33e95","TabRow":"TabRow-33e95","Tab":"Tab-33e95","TabActive":"TabActive-33e95","CardBody":"CardBody-33e95","IconCircle":"IconCircle-33e95","Description":"Description-33e95","MobileLayout":"MobileLayout-33e95","MobileItem":"MobileItem-33e95","MobilePill":"MobilePill-33e95","MobilePillActive":"MobilePillActive-33e95","MobileCardWrapper":"MobileCardWrapper-33e95","MobileCardOpen":"MobileCardOpen-33e95","MobileCardInner":"MobileCardInner-33e95","MobileCard":"MobileCard-33e95","MobileIconCircle":"MobileIconCircle-33e95","MobileDescription":"MobileDescription-33e95"}, { get: (m, k) => (typeof k === "string" ? (m[k] ?? k) : m[k]) });

export type FeatureCardItem = {
  title: string;
  description: string;
  iconUrl: string;
};

type Props = {
  items: FeatureCardItem[];
};

export default function TabbedFeatureCardsClient({ items }: Props) {
  const [activeIdx, setActiveIdx] = useState(0);
  const active = items[activeIdx];

  if (!items.length) return null;

  return (
    <div className={styles.Wrapper}>
      <div className={styles.Inner}>
        {/* Desktop */}
        <div className={styles.Card}>
          <div className={styles.TabRow}>
            {items.map((item, idx) => (
              <button
                key={idx}
                className={`${styles.Tab} ${idx === activeIdx ? styles.TabActive : ""}`}
                onClick={() => setActiveIdx(idx)}
              >
                {item.title}
              </button>
            ))}
          </div>
          <div className={styles.CardBody}>
            {active.iconUrl && (
              <div className={styles.IconCircle}>
                <Image
                  src={active.iconUrl}
                  alt={active.title}
                  width={132}
                  height={124}
                  style={{ objectFit: "contain" }}
                />
              </div>
            )}
            <p className={styles.Description}>{active.description}</p>
          </div>
        </div>

        {/* Mobile accordion */}
        <div className={styles.MobileLayout}>
          {items.map((item, idx) => {
            const isActive = idx === activeIdx;
            return (
              <div key={idx} className={styles.MobileItem}>
                <button
                  className={`${styles.MobilePill} ${isActive ? styles.MobilePillActive : ""}`}
                  onClick={() => setActiveIdx(idx)}
                >
                  {item.title}
                </button>
                <div className={`${styles.MobileCardWrapper} ${isActive ? styles.MobileCardOpen : ""}`}>
                  <div className={styles.MobileCardInner}>
                    <div className={styles.MobileCard}>
                      {item.iconUrl && (
                        <div className={styles.MobileIconCircle}>
                          <Image
                            src={item.iconUrl}
                            alt={item.title}
                            width={132}
                            height={124}
                            style={{ objectFit: "contain" }}
                          />
                        </div>
                      )}
                      <p className={styles.MobileDescription}>{item.description}</p>
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}
